/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "common": {
            "nested": {
              "account_scoped_identifier": {
                "nested": {
                  "AccountScopedIdentifier": {
                    "fields": {
                      "token": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "type": {
                        "type": ".squareup.bbfrontend.common.account_scoped_identifier.AccountScopedIdentifier.TokenType",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "TokenType": {
                        "values": {
                          "TOKEN_TYPE_UNKNOWN": 0,
                          "TOKEN_TYPE_UNIT": 1,
                          "TOKEN_TYPE_MERCHANT": 2
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.account_scoped_identifier?.nested?.AccountScopedIdentifier && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.account_scoped_identifier?.nested?.AccountScopedIdentifier?.nested?.TokenType) {
  $root.addJSON(jsonData);
}

/**
 * Defines the identifier, whether it's UNIT or MERCHANT scoped.
 *
 * SOURCE AccountScopedIdentifier @ squareup/bbfrontend/common/identifier/account_scoped_identifier.proto at 14:1
 */
export const AccountScopedIdentifier = $root.lookupType('squareup.bbfrontend.common.account_scoped_identifier.AccountScopedIdentifier');
fixType(AccountScopedIdentifier, {
  token: {
    notEmpty: true
  },
  type: {
    required: true
  }
});
Builder.createAndAttachToType(AccountScopedIdentifier);
/**
 * SOURCE TokenType @ squareup/bbfrontend/common/identifier/account_scoped_identifier.proto at 18:3
 */
AccountScopedIdentifier.TokenType = $root.lookupEnum('squareup.bbfrontend.common.account_scoped_identifier.AccountScopedIdentifier.TokenType').values;